import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareRefreshIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props}>
    <path
      d='M2.862 1.863L1 0h5v5L3.58 2.579a7 7 0 002.42 12.132v1.038A8.005 8.005 0 012.862 1.864v-.001zM10 1.289V.252a8.005 8.005 0 013.138 13.885L15 16h-5v-5l2.422 2.421A7 7 0 0010 1.29v-.001z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M14.137 2.863L16 1v5h-5l2.42-2.421A7 7 0 001.29 5.999H.25a8.005 8.005 0 0113.885-3.136zM14.71 10h1.037a8.005 8.005 0 01-13.885 3.138L0 15v-5h5l-2.421 2.422A7 7 0 0014.709 10h.002z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const RefreshIcon = memo(BareRefreshIcon);
